import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function VerifySent() {
  const location = useLocation();
  const { t } = useTranslation();
  const email = (location.state as { email?: string } | null)?.email;

  return (
    <div className="card">
      <h2 className="card-title">{t('verifySent.title')}</h2>
      <p className="card-subtitle">
        {email ? t('verifySent.bodyWithEmail', { email }) : t('verifySent.bodyNoEmail')}
      </p>

      <div className="alert alert-info">{t('verifySent.validity')}</div>

      <p className="muted-block">
        {t('verifySent.notArrivedPrefix')}
        <Link to="/register" className="text-link">{t('verifySent.notArrivedLink')}</Link>
        {t('verifySent.notArrivedSuffix')}
      </p>
    </div>
  );
}
